import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';

@Component({
  selector: 'ngx-route-forbidden',
  template: `
    <ng-sidebar-container>
      <div ng-sidebar-content>
        <ngx-page-container>
          <h1>Access denied</h1>
          <hr>
          You don't have permissions to access this page.
          <div class="sidebar footer text-center">
          <button class="btn btn-default btn-lg" (click)="back()">Back</button>
        </div>
          </ngx-page-container>
      </div>
    </ng-sidebar-container>
  `,
})
export class RouteForbiddenComponent {

  constructor(private router: Router, private location: Location) {
  }

  back() {
    this.location.back()
  }
}
